const withdrawConfig = [
    {
        subdomain: 'bg',
        product: 'playnixzone',
    },
    {
        subdomain: 'uk',
        product: 'mobiotv',
    },
];

export const checkWithdrawEnabled = (product, subdomain) => {
    return withdrawConfig.some((c) => c.product === product && c.subdomain === subdomain);
};
